import { DocumentTemplateType } from '../../../models/applications/application-documents';
import { Contract } from '../../../models/applications/contracts';
import { applicationDocumentsApi } from '../../../redux/api/applications/application-documents-api';
import { downloadFile } from '../../../utils/common';

export const useDownloadContractCustomerConsent = () => {
  const [generateDocument] =
    applicationDocumentsApi.useLazyGenerateDocumentQuery();

  return (contract: Contract) => {
    generateDocument({
      id: Number(contract.id),
      docType: DocumentTemplateType.PERSONAL_INFO_AGREEMENT_CUSTOMER,
    })
      ?.unwrap()
      .then(result => {
        downloadFile(
          new File(
            [result],
            'Согласие на обработку персональных данных (заказчика).docx'
          )
        );
      });
  };
};
